module.exports = __webpack_public_path__ + "static/media/CloseCircleBlack.9d6f52b3.svg";